import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotAllowed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		opacity: .78,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 30,
			cy: 30,
			r: 27.5,
			stroke: "#DDE3F0",
			strokeWidth: 5
		}), /* @__PURE__ */ _jsx("line", {
			x1: 9.53242,
			y1: 9.44879,
			x2: 49.0618,
			y2: 48.9782,
			stroke: "#DDE3F0",
			strokeWidth: 5
		})]
	})]
});
const ForwardRef = forwardRef(SvgNotAllowed);
export default ForwardRef;
